module.exports = __webpack_public_path__ + "img/logo-wide.46b760ff.jpeg";